const getAppVersion = () => ({
  appVersion: __APP_VERSION__ || '',
  commitHashShort: __COMMIT_HASH_SHORT__ || '',
  commitHashComplete: __COMMIT_HASH_COMPLETE__ || '',
  buildTime: __BUILD_TIME__ || ''
});

export default getAppVersion;
